import ElButton from './src/button';

ElButton.install = function (Vue) {
    Vue.component(ElButton.name, ElButton);
};

export default ElButton;


//////////////////
// WEBPACK FOOTER
// ./clu/packages/button/index.js
// module id = null
// module chunks = 